import { RESERVED_PRODUCTS } from "components/constants";

export default function getTotalQuantity(items) {
  return items
    .filter((item) => item.type !== RESERVED_PRODUCTS.cash_rounding)
    .reduce((num, item) => num + item.quantity, 0)
}
